export class FormBundleSignatureRequestApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getBundle({ loanId }) {
    return this.#http.get(`/FormBundleSignatureRequest/${loanId}`);
  }

  async getPdfDocumentBundle({ loanId, signatureId }) {
    return this.#http.get(
      `/FormBundleSignatureRequest/${loanId}/form-bundle-signature-request/${signatureId}/file`,
      { responseType: 'blob' },
    );
  }

  async correctGeneratedOutsideFormDeliveryDates({
    formDeliveryRequestId,
    applicationId,
    recipients,
  }) {
    return this.#http.put(
      `/FormBundleSignatureRequest/form-delivery/${formDeliveryRequestId}/generated-outside-dates`,
      { applicationId, recipients },
    );
  }
}
